import type { ActivityListResult } from '@ayub/shared'
import { ApiError, apiGet } from '@/lib/api'
import { getInitDataRaw } from '@/lib/telegram'

/**
 * `GET /api/activity` — server standart 1/20, maksimal sahifa hajmi 50 qabul qiladi
 * (`apps/server/src/api/routes/activity.ts`: `DEFAULT_PAGE_SIZE = 20`, `MAX_PAGE_SIZE = 50`).
 * "Yana ko'rsatish" tugmasi shu 20 tadan qo'shib boradi (`HistorySection.tsx`).
 */
export const HISTORY_PAGE_SIZE = 20

export function fetchActivity(
  entityType: string,
  entityId: number,
  page: number,
  pageSize: number = HISTORY_PAGE_SIZE,
): Promise<ActivityListResult> {
  const params = new URLSearchParams({
    entityType,
    entityId: String(entityId),
    page: String(page),
    pageSize: String(pageSize),
  })
  return apiGet<ActivityListResult>(`/activity?${params.toString()}`)
}

/**
 * `GET /api/files/:fileId` — rasm BAYTLARINI qaytaradi (proxy, `Content-Type: image/...`),
 * JSON EMAS. `lib/api.ts`dagi `apiGet()`ni shu uchun ishlatib bo'lmaydi (u har doim
 * `response.json()` kutadi) — shuning uchun mustaqil, minimal wrapper: xuddi `lib/api.ts`
 * (`buildHeaders`/`request`) dagi bilan bir xil autentifikatsiya naqshi (Telegram initData
 * `Authorization: tma <raw>` sarlavhasi + brauzer rejimida `credentials: 'same-origin'`
 * cookie'si), lekin `fetch()` to'g'ridan-to'g'ri shu yerda chaqiriladi — `lib/api.ts` boshqa
 * agent egaligida, uni TEGMASDAN o'zgartirib bo'lmaydi.
 *
 * Chaqiruvchi (`VideoChecksSection.tsx`dagi skrinshot modali) natijani
 * `URL.createObjectURL()` bilan ko'rsatadi va komponent yopilganda `URL.revokeObjectURL()`
 * bilan tozalaydi — xotira sizib qolmasin (blob URL'lar avtomatik tozalanmaydi).
 */
export async function fetchFileBlob(fileId: string): Promise<Blob> {
  const headers = new Headers()
  const raw = getInitDataRaw()
  if (raw) {
    headers.set('Authorization', `tma ${raw}`)
  }

  const response = await fetch(`/api/files/${encodeURIComponent(fileId)}`, {
    method: 'GET',
    headers,
    credentials: 'same-origin',
  })

  if (!response.ok) {
    throw new ApiError(response.status, response.statusText || "Rasmni yuklab bo'lmadi")
  }

  return response.blob()
}
